module.exports = __webpack_public_path__ + "static/works_02-71127610efcaeae3ec1ad57603995999.png";